var Vendd = (function (Vendd) {
	"use strict";
	Vendd.RequestReturn = (function (RequestReturn) {

		var model;
		var PendingProductCollection = []

		Vendd.MessageBus.subscribe(Vendd.RequestReturn.Messages.GetReturnRequest, Vendd.RequestReturn, function (envelope) {

			var endpoints = {
				byOrderInfo: "api/RequestReturn/GetReturnRequestByOrderInfo",
				byGlobalId: "api/RequestReturn/GetReturnRequestByGlobalId"
			};

			var options = {
				url: envelope.message.data.globalId ? endpoints.byGlobalId : endpoints.byOrderInfo,
				data: envelope.message.data,
				onSuccess: onSuccess,
				onFailure: onFailure
			};

			function onSuccess(response) {

				if (response.success) {

					model = response.data;
					$.each(model.Return.AvailableItemForReturn, function (idx, item) {
						item = updateProductFields(item);
					});
					$.each(model.Return.ReturnItems, function (idx, item) {
						item = updateProductFields(item);
					});

					Vendd.MessageBus.publishAsync(Vendd.RequestReturn, new Vendd.RequestReturn.Messages.GetReturnRequestSuccess(model));
				} else {
					response.validation = true;
					Vendd.MessageBus.publishAsync(Vendd.RequestReturn, new Vendd.RequestReturn.Messages.GetReturnRequestFailure(response));
				}
			}

			function onFailure(response) {
				Vendd.MessageBus.publishAsync(Vendd.RequestReturn, new Vendd.RequestReturn.Messages.GetReturnRequestError(response));
			}


			Vendd.Service.call(options);
		});

		Vendd.MessageBus.subscribe(Vendd.RequestReturn.Messages.SaveReturnItem, Vendd.RequestReturn, function (envelope) {

			var options = {
				url: "api/RequestReturn/SaveReturnItem",
				data: envelope.message.data,
				onSuccess: onSuccess,
				onFailure: onFailure
			};

			function onSuccess(response) {
				if (response.success) {
					model.Return.ReturnItems = response.data;
					$.each(model.Return.ReturnItems, function (idx, item) {
						item = updateProductFields(item);
					});
					Vendd.MessageBus.publishAsync(Vendd.RequestReturn, new Vendd.RequestReturn.Messages.SaveReturnItemSuccess(response));
				} else {
					Vendd.MessageBus.publishAsync(Vendd.RequestReturn, new Vendd.RequestReturn.Messages.SaveReturnItemFailure(response));
				}
			}

			function onFailure(response) {
				Vendd.MessageBus.publishAsync(Vendd.RequestReturn, new Vendd.RequestReturn.Messages.SaveReturnItemError(response));
			}

			Vendd.Service.call(options);
		});

		Vendd.MessageBus.subscribe(Vendd.RequestReturn.Messages.DeleteReturnItem, Vendd.RequestReturn, function (envelope) {

			var options = {
				url: "api/RequestReturn/DeleteReturnItem",
				data: {
					ReturnRequestGlobalId: model.Return.GlobalId,
					ReturnItemGlobalId: envelope.message.data
				},
				onSuccess: onSuccess,
				onFailure: onFailure
			};

			function onSuccess(response) {
				if (response.success) {
					model.Return.ReturnItems = response.data;
					$.each(model.Return.ReturnItems, function (idx, item) {
						item = updateProductFields(item);
					});
					Vendd.MessageBus.publishAsync(Vendd.RequestReturn, new Vendd.RequestReturn.Messages.DeleteReturnItemSuccess(response));
				} else {
					Vendd.MessageBus.publishAsync(Vendd.RequestReturn, new Vendd.RequestReturn.Messages.DeleteReturnItemFailure(response));
				}
			}

			function onFailure(response) {
				Vendd.MessageBus.publishAsync(Vendd.RequestReturn, new Vendd.RequestReturn.Messages.DeleteReturnItemError(response));
			}

			Vendd.Service.call(options);
		});

		Vendd.MessageBus.subscribe(Vendd.RequestReturn.Messages.SubmitOrderReturn, Vendd.RequestReturn, function (envelope) {
			var data = envelope.message.data;
			data.GlobalId = model.Return.GlobalId;

			var options = {
				url: "api/RequestReturn/SubmitReturnRequest",
				data: data,
				onSuccess: onSuccess,
				onFailure: onFailure
			};

			function onSuccess(response) {
				if (response.success) {
					Vendd.MessageBus.publishAsync(Vendd.RequestReturn, new Vendd.RequestReturn.Messages.SubmitOrderReturnSuccess(response));
					Vendd.MessageBus.publishAsync(Vendd.RequestReturn, new Vendd.RequestReturn.Messages.SendReturnRequestNotification(model.Return.GlobalId));
				} else {
					Vendd.MessageBus.publishAsync(Vendd.RequestReturn, new Vendd.RequestReturn.Messages.SubmitOrderReturnsFailed(response));
				}
			}

			function onFailure(response) {
				Vendd.MessageBus.publishAsync(Vendd.RequestReturn, new Vendd.RequestReturn.Messages.SubmitOrderReturnsFailed(response));
			}

			Vendd.Service.call(options);
		});

		Vendd.MessageBus.subscribe(Vendd.RequestReturn.Messages.SendReturnRequestNotification, Vendd.RequestReturn, function (envelope) {
			var options = {
				url: "api/RequestReturn/ReturnRequestNotification",
				data: { GlobalId: envelope.message.data }
			};

			Vendd.Service.call(options);
		});

        Vendd.MessageBus.subscribe(Vendd.RequestReturn.Messages.CheckOrderSession, Vendd.RequestReturn, function () {

            var options = {
                url: "api/RequestReturn/CheckOrderSession",
                onSuccess: onSuccess,
                onFailure: onFailure
            };

            function onSuccess(response) {

                if (response.success) {

                    model = response.data;
                    $.each(model.Return.AvailableItemForReturn, function (idx, item) {
                        item = updateProductFields(item);
                    });
                    $.each(model.Return.ReturnItems, function (idx, item) {
                        item = updateProductFields(item);
                    });

                    Vendd.MessageBus.publishAsync(Vendd.RequestReturn, new Vendd.RequestReturn.Messages.GetReturnRequestSuccess(model));
                } else {
                    response.validation = true;
                    Vendd.MessageBus.publishAsync(Vendd.RequestReturn, new Vendd.RequestReturn.Messages.GetReturnRequestFailure(response));
                }
            }

            function onFailure(response) {
                //Vendd.MessageBus.publishAsync(Vendd.RequestReturn, new Vendd.RequestReturn.Messages.GetReturnRequestError(response));
            }


            Vendd.Service.call(options);
        });

		Vendd.RequestReturn.GetMaxQuantityToAdd = function (orderitemid) {
			var activeQuantity = _.reduce($.grep(model.Return.ReturnItems, function (x) { return x.OrderItemId === orderitemid }), function (memo, x) { return memo + x.Quantity; }, 0);
			var maxQuantity = _.reduce($.grep(model.Return.AvailableItemForReturn, function (x) { return x.OrderItemId == orderitemid }), function (memo, x) { return memo + x.Quantity - x.ReturnQuantity; }, 0);
			var result = maxQuantity - activeQuantity;
			return result > 0 ? result : 0;
		};

		Vendd.RequestReturn.GetProductToAdd = function (OrderitemId) {
			var product = $.extend({}, _.first(_.filter(model.Return.AvailableItemForReturn, function (x) { return x.OrderItemId == OrderitemId; })));
			product.UploadServiceUrl = model.UploadServiceUrl;
			product.Quantity = 1;
			product.MaxQuantity = Vendd.RequestReturn.GetMaxQuantityToAdd(product.OrderItemId);
			product.MaxQuantityLabel = product.Literals.MaxQuantityText.replace('{{MaxQuantity}}', product.MaxQuantity);
			return product;
		};

		Vendd.RequestReturn.GetProductByGlobalId = function (globalId) {
			var product = $.extend({}, _.first(_.filter(model.Return.ReturnItems, function (x) { return x.GlobalId == globalId; })))
			product.MaxQuantity = Vendd.RequestReturn.GetMaxQuantityToAdd(product.OrderItemId) + product.Quantity;
			product.MaxQuantityLabel = product.Literals.MaxQuantityText.replace('{{MaxQuantity}}', product.MaxQuantity);
			product.UploadServiceUrl = model.UploadServiceUrl;
			return product;
		};

		Vendd.RequestReturn.RemoveResource = function (rowid, resource) {
			$.each(PendingProductCollection, function (x, product) {
				if (x.RowId == rowid) {
					product.Resources = $.grep(product.Resources, function (x) {
						return x.Uri == resource;
					});
				}
			});
		};

		function updateProductFields(item) {
			item = item || {};
			item.Literals = {
				Save: model.Literals.Save,
				SKUText: model.Literals.SKUText,
				ProductText: model.Literals.ProductText,
				QuantityText: model.Literals.QuantityText,
				ProductConditionText: model.Literals.ProductConditionText,
				PhotosText: model.Literals.PhotosText,
				CommentsText: model.Literals.CommentsText,
				ResendText: model.Literals.ResendText,
				AttachText: model.Literals.AttachText,
				PhotosLimitText: model.Literals.PhotosLimitText,
				SelectConditionText: model.Literals.SelectConditionText,
				MaxQuantityText: model.Literals.MaxQuantityText,
				QuantityRequiredText: model.Literals.QuantityRequiredText,
				ImagesRequiredText: model.Literals.ImagesRequiredText,
				ResendLabel: model.Literals.ResendLabel,
				CommentsPlaceholder: model.Literals.CommentsPlaceholder,
				YesText: model.Literals.YesText,
				NoText: model.Literals.NoText,
				StatusRequiredText: model.Literals.StatusRequiredText
			};
			item.ReturnRequestGlobalId = model.Return.GlobalId;
			item.ReturnItemGlobalId = item.GlobalId;
			item.AvailableQuantityForReturn = item.Quantity - item.ReturnQuantity;
			item.AvailableConditions = model.Return.AvailableConditions;
			item.DropdownProductDescription = model.Literals.DropdownProductDescription.replace('{{ProductCode}}', item.ProductCode).replace('{{ReturnQuantity}}', item.ReturnQuantity).replace('{{Quantity}}', item.Quantity);
			return item;
		}

		return RequestReturn;
	})(Vendd.RequestReturn || {});

	return Vendd;
})(Vendd || {});
